import DownloadNH from "../Common/DownloadNH";
import ExclusiveOffers from "../Common/ExclusiveOffers";
import FaqSection from "../Common/FaqSection";
import HolidayPackageSection from "../Common/HolidayPackageSection";
import SeeTheWorld from "../Common/SeeTheWorld";
import TravelInsights from "../Common/TravelInsights/TravelInsights";
import MainLayout from "../MainLayout";
import ThingsstodoNeedToKnow from "./ThingsstodoNeedToKnow/ThingsstodoNeedToKnow";
import ThingsToDoHeader from "./ThingsToDoHeader/ThingsToDoHeader";

export default function ThingsToDo({ slug, pageData = null }) {
  const activityItems = pageData?.activitySection?.items || [];
  const holidayItems = pageData?.holidaySection?.items || [];
  const travelInsights = pageData?.travelInsights || {};
  const faqs = pageData?.faqs || [];
  const heading = pageData?.heading || {};
  const cityName = pageData?.detail?.cityName || "Dubai";

  return (
    <MainLayout hideHeader>
      <ThingsToDoHeader detail={pageData?.detail} />
      <ExclusiveOffers />
      <HolidayPackageSection
        title={pageData?.activitySection?.title || `Top Things To Do In ${cityName}`}
        subtitle={
          pageData?.activitySection?.description ||
          "Uncover your ideal escape, customized to your preferences."
        }
        moduleType="activity"
        data={activityItems}
        hideWhenEmpty
      />
      <HolidayPackageSection
        title={pageData?.holidaySection?.title}
        subtitle={pageData?.holidaySection?.description}
        moduleType="holiday"
        data={holidayItems}
        hideWhenEmpty
      />
      <ThingsstodoNeedToKnow needToKnow={pageData?.needToKnow} />
      {travelInsights.items?.length ? (
        <TravelInsights
          title={travelInsights.title || "Travel Insights"}
          data={travelInsights.items}
          mobileCarousel
        />
      ) : null}
      <SeeTheWorld
        title={heading.title || `What To Do In ${cityName}?`}
        text={heading.description || undefined}
        pageType={
          heading.title || heading.description ? undefined : "thingstodo"
        }
      />
      <FaqSection items={faqs} />
      <DownloadNH />
    </MainLayout>
  );
}
